const getters = {

    userInfo: state => state.user.userInfo,

    menuIndex: state => state.user.menuIndex,
    isMobile: state => state.user.isMobile,
    dict: state => state.dict.dict,
    regionCode: state => state.region.region,
    regionName: state => state.region.regionName,
    regionLocale: state => state.region.locale,
    regionPaymentMethods: state => state.region.paymentMethods,
    regionDefaultPmId: state => state.region.defaultPmId,
    regionLoaded: state => state.region.loaded
}
export default getters
